import { App, URLOpenListenerEvent } from '@capacitor/app';
import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

const AppUrlListener = () => {
  const history = useHistory();
  useEffect(() => {
    if (!App.addListener) return;
    (async () => {
      await App.addListener('appUrlOpen', (event: URLOpenListenerEvent) => {
        const slug = event.url.split('.withlocals.com').pop();
        if (slug) {
          history.push(slug);
        }
      });
    })();
  }, [history]);

  return null;
};

export default AppUrlListener;
